<kilowant-header [isHome]="true" title="Sign In" linkHome="/"></kilowant-header>
<div class="login-form wrapper-main-public-area">
    <div class="form" style="margin-top: calc(50vh - 260px)">
        <div class="login-mode">
            <input type="text" id="login" name="login" value="" (input)="resetError()" autocomplete="new-text" [style]="(loginEmail()!=null)?'background-color: #eee':''" [disabled]="loginEmail()!=null" [(ngModel)]="login" placeholder="Email address" />
            <input type="password" id="password" name="password" value="" (input)="resetError()" [type]="passwordType"
                   [(ngModel)]="password" placeholder="Password" />
            <div class="password-holder" (click)="showPassword()">
                <i [class]="(passwordType=='password')?'password-show':'password-hide'"></i>
            </div>
        </div>
        <div class="placeholder" style="text-align: right; padding-right: 28px;"><a (click)="goToForgotPassword()">Forgot password?</a></div>
        @if (this.loginEmail()!=null) {
           <div style="text-align: right"><a (click)="clearLoginUser()" class="link">Login as different user</a></div>
        }
        @if (this.showError && error!=null && error.length>0) {
        <div class="error-block">{{error}}</div>
        }
        @if (showSendActivation) {
        <div class="error-block">
            Your account already exists, but not activated.<br /><br />Please, <a href="/user/activation?email={{login}}">click here</a> to send an activation link again.
        </div>
        }
        <div class="footerText">By signing in, you agree to our<br /><a (click)="goto('/tou')">Terms of Use</a> and <a (click)="goto('/privacy-policy')">Privacy Policy</a></div>
        <div class="login-button-area mt-10">
            <button type="button" class="loginBtnsBorder" (click)="sendForm()">Sign In</button>
        </div>
    </div>
</div>
